import * as ACTIONS from './actions';
import * as MUTATIONS from './mutations';

const state = {
  title: '',
  messages: [],
  isVisible: false,
  type: 'info',
};

const actions = {
  [ACTIONS.updateMessage]: ({ commit }, message) => {
    commit(MUTATIONS.SET_MESSAGE, message);
  },
  [ACTIONS.updateVisibility]: ({ commit }, value) => {
    commit(MUTATIONS.SET_VISIBILITY, value);
    if (!value) commit(MUTATIONS.RESET_ALL);
  },
  [ACTIONS.showSnackbarWithMessage]: ({ commit }, { title = '', message = '', type = 'info' }) => {
    commit(MUTATIONS.SET_TITLE, title);
    commit(MUTATIONS.SET_MESSAGE, (message || '').split('\n'));
    commit(MUTATIONS.SET_TYPE, type);
    commit(MUTATIONS.SET_VISIBILITY, true);
  },
};

const mutations = {
  [MUTATIONS.SET_TITLE]: (state, value) => (state.title = value),
  [MUTATIONS.SET_MESSAGE]: (state, message) => {
    if (Array.isArray(message)) state.messages = message;
    else state.messages = [message];
  },
  [MUTATIONS.SET_VISIBILITY]: (state, value) => (state.isVisible = value),
  [MUTATIONS.SET_TYPE]: (state, value) => (state.type = value),

  [MUTATIONS.RESET_ALL]: (state) => {
    state.isVisible = false;
    state.messages = [];
    state.title = '';
    state.type = 'info';
  },
};

export default {
  state,
  actions,
  mutations,
};
